import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';
import Preloader from '../img/preloader.gif';
import Api from '../config/Api';

class EgfrCalculate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			token: (localStorage.token ? localStorage.token : sessionStorage.token),
			fileID: this.props.match.params.id,
            calculationDone: false,
            loadingContents: false
		}
	}

    generateCalculation = () => {
        var self = this;
        this.setState({
            loadingContents: true
        }, function() {
            Api.generateCalculation(JSON.stringify({ token: this.state.token, fileID: this.state.fileID }), function(response) {
                self.setState({
                    calculationDone: true
                });
            });
        });
    }

    render() {
    	return(
    		<div className="blockCtr patients br10 sh1">
    			<div className="blockHeader br10Top">
    				<Link to="/egfr" className="backBtn br10TopLeft"><span className="fas fa-chevron-left"></span></Link>
    				<h3>eGFR Calculation</h3>
    			</div>
    			<div className="blockInfo" style={{ display: (this.state.loadingContents ? 'none' : 'block') }}>
                    Click on the button below to begin the calculation. Please keep in mind that this process could take up to 5 minutes depending on the size of the file.<br /><br />
                    <div className="row stepConfig" style={{paddingTop: 20}}>
                        <div className="col-12 ar">
                            <button className="goBtn btn br5 anim1" onClick={this.generateCalculation} style={{display: 'inline-block'}}>Generate calculation</button>
                        </div>
                    </div>
    			</div>
                <div className="blockInfo" style={{ display: (this.state.loadingContents ? 'block' : 'none') }}>
                    {this.state.calculationDone ? '' : <div><p style={{ textAlign: 'center' }}>Please be patient, as this process could take a while.<br />Do not leave this page in order to finish correctly.</p><img src={Preloader} alt="Fresenius Preloader" className="preloader" style={{display: 'block', maxHeight: 'auto'}} /></div>}
                    <div style={{ display: (this.state.calculationDone ? 'block' : 'none') }}>
                        The eGFR calculation has been completed successfully.<br /><br />
                        <div className="row stepConfig" style={{paddingTop: 20}}>
                            <div className="col-12 ar">
                                <Link className="goBtn btn br5 anim1" to="/egfr" style={{display: 'inline-block'}}>Go to eGFR</Link>
                            </div>
                        </div>
                    </div>
                </div>
    		</div>
    	);
    }
}

export default EgfrCalculate;


// WEBPACK FOOTER //
// ./src/components/EgfrCalculate.js